import { render, staticRenderFns } from "./Motds.vue?vue&type=template&id=28af84d7&"
import script from "./Motds.vue?vue&type=script&lang=ts&"
export * from "./Motds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28af84d7')) {
      api.createRecord('28af84d7', component.options)
    } else {
      api.reload('28af84d7', component.options)
    }
    module.hot.accept("./Motds.vue?vue&type=template&id=28af84d7&", function () {
      api.rerender('28af84d7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Motds.vue"
export default component.exports